import Reflux from 'reflux';
import EventData from 'shared/data/Event';
import TeamData from 'shared/data/Team';
import UserActions from 'flux/actions/UserActions';

/* eslint-disable no-unused-vars */
var loadedFromSession = UserActions.loadFromSession.completed;

var loadedPromise = new Promise((ful) => {
  loadedFromSession.listen((user) => ful(user));
});
/* eslint-enable no-unused-vars */

let async = { asyncResult: true },
  UserEventListActions = Reflux.createActions({
    populate: async,
    populateOwners: async,
    populateLabels: async,
    getPage: async,
    getTeams: async,
    page: {},
    notifyFilterChange: {}, //Used primarily to trigger spinner in SpinnerStore
    populateRecentEvents: async,
    populatePastEvents: async,
    populateAllEvents: {},
    hideRecentEvents: {},
  });

//TODO: make this happen only after the UserActions.loadFromSession() has completed..

UserEventListActions.getTeams.listenAndPromise((userId) =>
  TeamData.getByUserId(userId).then((userTeamObjects) => {
    const teams = [];
    userTeamObjects.forEach((data) => teams.push(data.team));
    return teams;
  }),
);

UserEventListActions.populate.listenAndPromise((user, query) => {
  return EventData.getByUserId(user._id, query);
});

UserEventListActions.populateRecentEvents.listenAndPromise((user, query) => {
  return EventData.getByUserId(user._id, query);
});

UserEventListActions.populatePastEvents.listenAndPromise((user, query) => {
  return EventData.getByUserId(user._id, query);
});

UserEventListActions.getPage.listenAndPromise(EventData.getByUserId);
UserEventListActions.populateOwners.listenAndPromise(
  EventData.getAllOwnersByUserId,
);
UserEventListActions.populateLabels.listenAndPromise(
  EventData.getAllLabelsByUserId,
);

export default UserEventListActions;
